module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAASCAYAAABrXO8xAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEvSURBVHgBlVPdTYRAEB5gSQhPWMFZgiWcFehVoCQkhCe1ArECfSEEQsLZwXXgdSJ2wCP/+C05CDl34Zxksr/fzvfNzCpxHD/1fe8TkUXLlnVdd+t5XsYXjIPgn/DDEkrTtFfumNoDkEdijL07jvOzBAzDcAvgZlyzcZKmqVUUxR+6I7X5vaqqUnXcAOhDVdXvc0+SZDMHnh6/nyIahvGMTf88ouu6QgkT0LbtHENOF9oEhHgf1B5El5qm2UmBsD3qlImApmlmkCEGnrK3J4mBEcmoPqJOQqp1Xb+QjCr05TKq/EwKRNp5yx0upTo0QFmWV/RPY4qiHNGrX1EUrdXQatt20sp0Xd+h97bQt/qtkPkjKF/zhTI/CYLgBolYfADndzTv1SE8KNP6h+aS3n4BxMl99YgP8akAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hours-icon.png
// module id = VExU
// module chunks = 1